import { CaretRightOutlined, PlusOutlined, ToolOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';
import { INQUIRY_FEE_TITLE_MAP, INQUIRY_FEE_TYPE } from './inquiryFeeTypes';

// Metadata hiển thị header của mỗi thread option (icon + nhãn JP).
export interface InquiryOption {
  value: string; // = optionType (InquiryFeeType)
  label: string; // tiêu đề JP
  icon: ReactNode; // icon nhỏ ở đầu header card
}

// Sparkle (清掃) — antd chưa có icon lấp lánh nên tự vẽ, tô theo currentColor.
const SparkleIcon = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor" aria-hidden>
    <path d="M512 96c14 0 26 9 30 22l52 168a160 160 0 0 0 104 104l168 52a32 32 0 0 1 0 60l-168 52a160 160 0 0 0-104 104l-52 168a32 32 0 0 1-60 0l-52-168a160 160 0 0 0-104-104l-168-52a32 32 0 0 1 0-60l168-52a160 160 0 0 0 104-104l52-168c4-13 16-22 30-22z" />
    <path d="M232 640c8 0 15 5 18 13l22 68a72 72 0 0 0 46 46l68 22a19 19 0 0 1 0 36l-68 22a72 72 0 0 0-46 46l-22 68a19 19 0 0 1-36 0l-22-68a72 72 0 0 0-46-46l-68-22a19 19 0 0 1 0-36l68-22a72 72 0 0 0 46-46l22-68c3-8 10-13 18-13z" />
  </svg>
);

// Special packing / その他 (特別梱包) — hộp 3D, tô theo currentColor.
const PackageIcon = () => (
  <svg
    viewBox="0 0 1024 1024"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth={72}
    strokeLinejoin="round"
    strokeLinecap="round"
    aria-hidden
  >
    <path d="M512 96 128 288v448l384 192 384-192V288L512 96z" />
    <path d="M128 288l384 192 384-192M512 480v448M320 192l384 192" />
  </svg>
);

export const INQUIRY_OPTION_MAP: Record<string, InquiryOption> = {
  [INQUIRY_FEE_TYPE.OPERATION_CHECK]: {
    value: INQUIRY_FEE_TYPE.OPERATION_CHECK,
    label: INQUIRY_FEE_TITLE_MAP[INQUIRY_FEE_TYPE.OPERATION_CHECK],
    icon: <CaretRightOutlined />,
  },
  [INQUIRY_FEE_TYPE.CLEANING]: {
    value: INQUIRY_FEE_TYPE.CLEANING,
    label: INQUIRY_FEE_TITLE_MAP[INQUIRY_FEE_TYPE.CLEANING],
    icon: <SparkleIcon />,
  },
  [INQUIRY_FEE_TYPE.ACCESSORY_ADD]: {
    value: INQUIRY_FEE_TYPE.ACCESSORY_ADD,
    label: INQUIRY_FEE_TITLE_MAP[INQUIRY_FEE_TYPE.ACCESSORY_ADD],
    icon: <PlusOutlined />,
  },
  [INQUIRY_FEE_TYPE.REPAIR]: {
    value: INQUIRY_FEE_TYPE.REPAIR,
    label: INQUIRY_FEE_TITLE_MAP[INQUIRY_FEE_TYPE.REPAIR],
    icon: <ToolOutlined />,
  },
  [INQUIRY_FEE_TYPE.OTHER]: {
    value: INQUIRY_FEE_TYPE.OTHER,
    label: INQUIRY_FEE_TITLE_MAP[INQUIRY_FEE_TYPE.OTHER],
    icon: <PackageIcon />,
  },
};

// Trả về option metadata theo optionType; null (thread chung) → undefined.
export const getInquiryOption = (optionType?: string | null): InquiryOption | undefined =>
  optionType ? INQUIRY_OPTION_MAP[optionType] : undefined;

// Các loại admin được phép ĐỔI SANG ở header card. Khớp chip bên USER (đã ẩn `other`/特別梱包):
// thread cũ đang là その他手数料 vẫn hiển thị đúng nhãn qua INQUIRY_OPTION_MAP, chỉ không chọn lại được.
export const CHANGEABLE_INQUIRY_OPTIONS: InquiryOption[] = [
  INQUIRY_OPTION_MAP[INQUIRY_FEE_TYPE.OPERATION_CHECK],
  INQUIRY_OPTION_MAP[INQUIRY_FEE_TYPE.CLEANING],
  INQUIRY_OPTION_MAP[INQUIRY_FEE_TYPE.ACCESSORY_ADD],
  INQUIRY_OPTION_MAP[INQUIRY_FEE_TYPE.REPAIR],
];
